import { render } from "./PreviewAsset.vue?vue&type=template&id=a7b8aa82"
import script from "./PreviewAsset.vue?vue&type=script&lang=js"
export * from "./PreviewAsset.vue?vue&type=script&lang=js"

import "./PreviewAsset.vue?vue&type=style&index=0&id=a7b8aa82&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__